import { Helmet } from "react-helmet";
import img from "../assets/images/ogp/ogp.png";

const HeadTag = () => {
  return (
    <Helmet
      title="【公式】myO2（マイオーツー）｜自分の髪に、本当に合うものを。"
      meta={[
        {
          name: "description",
          content:
            "「毎日毎秒の呼吸で酸素がわたしたちの体に栄養をめぐらせるように美容酸素水がパサついた髪の毛を奥深くまで水分で満たします毛先が広がりやすい太髪の方毛先がからまりやすい細髪の方どれを試しても、なかなか実感できない何を使ったら良いかわからない、という方へそれぞれの髪質に合わせて最適な仕上がりを提供します」",
        },
        {
          property: "og:title",
          content:
            "【公式】myO2（マイオーツー）｜自分の髪に、本当に合うものを。",
        },
        {
          property: "og:description",
          content:
            "「毎日毎秒の呼吸で酸素がわたしたちの体に栄養をめぐらせるように美容酸素水がパサついた髪の毛を奥深くまで水分で満たします毛先が広がりやすい太髪の方毛先がからまりやすい細髪の方どれを試しても、なかなか実感できない何を使ったら良いかわからない、という方へそれぞれの髪質に合わせて最適な仕上がりを提供します」",
        },
        {
          property: "og:image",
          content: img,
        },
      ]}
    ></Helmet>
  );
};

export default HeadTag;
